module.exports = __webpack_public_path__ + "static/img/logo-nexmo-dark.d0b341d1.png";